import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';
import { getQuery } from '@/helpers/utils';

export const complianceService = {
  notifications: () => axios.get(Pathes.Compliance.notifications),
  detail: case_id =>
    axios.get(Pathes.Compliance.amlCaseStatus + getQuery({ case_id })),
  submitCase: payload => axios.post(Pathes.Compliance.amlCaseStatus, payload),
  dismissNotification: caseId =>
    axios.post(Pathes.Compliance.notificationDismiss(caseId)),
};
